import defaultValues from '../lib/defaultValues.js'
import branch from 'branch-sdk'
import QRCode from 'qrcode'

const state = {
  branchLink: defaultValues.lenderBranchLink,
  branchQRCode: defaultValues.lenderBranchQRCode,
  brokerageName: defaultValues.lenderBrokerageName,
  brokeragePicture: defaultValues.lenderBrokeragePicture,
  licenseNumber: defaultValues.lenderLicenseNumber,
  phoneNumber: defaultValues.lenderPhoneNumber,
  profilePicture: defaultValues.lenderProfilePicture,
  lenderCode: defaultValues.lenderCode,
  lenderCognitoId: defaultValues.lenderCognitoId,
  lenderBackgroundColor: defaultValues.lenderBackgroundColor,
  lenderEmail: defaultValues.lenderEmail,
  lenderName: defaultValues.lenderName,
  lenderPaymentHistory: JSON.parse(JSON.stringify(defaultValues.lenderPaymentHistory)),
  lenderTextColor: defaultValues.lenderTextColor,
  subscriptionId: defaultValues.lenderSubscriptionId,
  subscriptionPrice: defaultValues.lenderSubscriptionPrice,
  subscriptionDiscountAmount: defaultValues.lenderSubscriptionDiscountAmount,
  subscriptionDiscountExpirationDate: defaultValues.lenderSubscriptionDiscountExpirationDate,
  subscriptionStartDate: defaultValues.lenderSubscriptionStartDate,
  subscriptionEndDate: defaultValues.lenderSubscriptionEndDate,
  subscriptionNextBillingDate: defaultValues.lenderSubscriptionNextBillingDate,
  subscriptionCreditCardType: defaultValues.lenderSubscriptionCreditCardType,
  subscriptionCreditCardLastFour: defaultValues.lenderSubscriptionCreditCardLastFour,
  subscriptionCustomFlag: defaultValues.lenderSubscriptionCustomFlag,
  subscriptionRenewal: defaultValues.lenderSubscriptionRenewal,
  clientIds: JSON.parse(JSON.stringify(defaultValues.lenderClientIds)),
  braintreeCustomerId: defaultValues.lenderBraintreeCustomerId,
  premium: defaultValues.lenderPremium
}

const getters = {
  getBranchLink: (state) => {
    return state.branchLink
  },
  getBranchQRCode: (state) => {
    return state.branchQRCode
  },
  getBrokerageName: (state) => {
    return state.brokerageName
  },
  getBrokeragePicture: (state) => {
    if (state.brokeragePicture && window.CONFIG && state.lenderCognitoId && state.brokeragePicture.includes(state.lenderCognitoId)) {
      let baseURL = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/'
      return baseURL + state.brokeragePicture
    }
    return state.brokeragePicture
  },
  getLicenseNumber: (state) => {
    return state.licenseNumber
  },
  getPhoneNumber: (state) => {
    if (!state.phoneNumber) return state.phoneNumber
    let x = state.phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
  },
  getProfilePicture: (state) => {
    if (state.profilePicture && window.CONFIG && state.lenderCognitoId && state.profilePicture.includes(state.lenderCognitoId)) {
      let baseURL = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/'
      return baseURL + state.profilePicture
    }
    return state.profilePicture
  },
  getLenderCode: (state) => {
    return state.lenderCode
  },
  getLenderCognitoId: (state) => {
    return state.lenderCognitoId
  },
  getLenderBackgroundColor: (state) => {
    return state.lenderBackgroundColor
  },
  getLenderEmail: (state) => {
    return state.lenderEmail
  },
  getLenderName: (state) => {
    return state.lenderName
  },
  getLenderPaymentHistory: (state) => {
    return state.lenderPaymentHistory
  },
  getLenderTextColor: (state) => {
    return state.lenderTextColor
  },
  getSubscriptionId: (state) => {
    return state.subscriptionId
  },
  getSubscriptionPrice: (state) => {
    return state.subscriptionPrice
  },
  getSubscriptionDiscountAmount: (state) => {
    return state.subscriptionDiscountAmount
  },
  getSubscriptionDiscountExpirationDate: (state) => {
    return state.subscriptionDiscountExpirationDate
  },
  getSubscriptionStartDate: (state) => {
    return state.subscriptionStartDate
  },
  getSubscriptionEndDate: (state) => {
    return state.subscriptionEndDate
  },
  getSubscriptionNextBillingDate: (state) => {
    return state.subscriptionNextBillingDate
  },
  getSubscriptionRenewal: (state) => {
    return state.subscriptionRenewal
  },
  getSubscriptionCreditCardType: (state) => {
    return state.subscriptionCreditCardType
  },
  getSubscriptionCreditCardLastFour: (state) => {
    return state.subscriptionCreditCardLastFour
  },
  getSubscriptionCustomFlag: (state) => {
    return state.subscriptionCustomFlag
  },
  getClientIds: (state) => {
    return state.clientIds
  },
  getBraintreeCustomerId: (state) => {
    return state.braintreeCustomerId
  },
  getPremium: (state) => {
    return state.premium
  }
}

const mutations = {
  updateBranchLink: (state, branchLink) => {
    state.branchLink = branchLink
  },
  updateBranchQRCode: (state, branchQRCode) => {
    state.branchQRCode = branchQRCode
  },
  updateBrokerageName: (state, brokerageName) => {
    state.brokerageName = brokerageName
  },
  updateBrokeragePicture: (state, brokeragePicture) => {
    state.brokeragePicture = brokeragePicture
  },
  updateLicenseNumber: (state, licenseNumber) => {
    state.licenseNumber = licenseNumber
  },
  updatePhoneNumber: (state, phoneNumber) => {
    if (phoneNumber) phoneNumber = phoneNumber.match(/(\d+)/g).join('')
    state.phoneNumber = phoneNumber
  },
  updateProfilePicture: (state, profilePicture) => {
    state.profilePicture = profilePicture
  },
  updateLenderCode: (state, lenderCode) => {
    state.lenderCode = lenderCode
  },
  updateLenderCognitoId: (state, lenderCognitoId) => {
    state.lenderCognitoId = lenderCognitoId
  },
  updateLenderBackgroundColor: (state, lenderBackgroundColor) => {
    state.lenderBackgroundColor = lenderBackgroundColor
  },
  updateLenderEmail: (state, lenderEmail) => {
    state.lenderEmail = lenderEmail
  },
  updateLenderName: (state, lenderName) => {
    state.lenderName = lenderName
  },
  updateLenderPaymentHistory: (state, lenderPaymentHistory) => {
    state.lenderPaymentHistory = lenderPaymentHistory
  },
  updateLenderTextColor: (state, lenderTextColor) => {
    state.lenderTextColor = lenderTextColor
  },
  updateSubscriptionId: (state, subscriptionId) => {
    state.subscriptionId = subscriptionId
  },
  updateSubscriptionPrice: (state, subscriptionPrice) => {
    state.subscriptionPrice = subscriptionPrice
  },
  updateSubscriptionDiscountAmount: (state, subscriptionDiscountAmount) => {
    state.subscriptionDiscountAmount = subscriptionDiscountAmount
  },
  updateSubscriptionDiscountExpirationDate: (state, subscriptionDiscountExpirationDate) => {
    state.subscriptionDiscountExpirationDate = subscriptionDiscountExpirationDate
  },
  updateSubscriptionStartDate: (state, subscriptionStartDate) => {
    state.subscriptionStartDate = subscriptionStartDate
  },
  updateSubscriptionEndDate: (state, subscriptionEndDate) => {
    state.subscriptionEndDate = subscriptionEndDate
  },
  updateSubscriptionNextBillingDate: (state, subscriptionNextBillingDate) => {
    state.subscriptionNextBillingDate = subscriptionNextBillingDate
  },
  updateSubscriptionRenewal: (state, subscriptionRenewal) => {
    state.subscriptionRenewal = subscriptionRenewal
  },
  updateSubscriptionCreditCardType: (state, subscriptionCreditCardType) => {
    state.subscriptionCreditCardType = subscriptionCreditCardType
  },
  updateSubscriptionCreditCardLastFour: (state, subscriptionCreditCardLastFour) => {
    state.subscriptionCreditCardLastFour = subscriptionCreditCardLastFour
  },
  updateSubscriptionCustomFlag: (state, subscriptionCustomFlag) => {
    state.subscriptionCustomFlag = subscriptionCustomFlag
  },
  updateClientIds: (state, clientIds) => {
    state.clientIds = clientIds
  },
  updateBraintreeCustomerId: (state, braintreeCustomerId) => {
    state.braintreeCustomerId = braintreeCustomerId
  },
  updatePremium: (state, premium) => {
    state.premium = premium
  }
}

const actions = {
  async getBtToken ({ commit, state, rootGetters }) {
    var client = rootGetters.getLenderApigClientFactory
    var params = {}
    var pathTemplate = '/lenders/bt-token'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async getPaymentHistory ({ commit, state, rootGetters }) {
    var client = rootGetters.getLenderApigClientFactory
    var params = {}
    var pathTemplate = '/lenders/paymenthistory'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    try {
      if ('data' in result) commit('updateLenderPaymentHistory', result.data)
    } catch (error) {
      console.log(error)
    }
  },
  async premiumSignup ({ commit, state, rootGetters }, parameters) {
    var client = rootGetters.getLenderApigClientFactory
    var params = {}
    var pathTemplate = '/lenderpremium/signup'
    var method = 'POST'
    var additionalParams = {}
    var body = {
      'payment_method_nonce': parameters.payload.nonce,
      'promotion_code': parameters.code
    }
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async switchRenewalStatus ({ commit, state, rootGetters }) {
    var client = rootGetters.getLenderApigClientFactory
    var params = {}
    var pathTemplate = '/lenderpremium/switch'
    var method = 'PATCH'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async getCurrentLenderData ({ commit, state, rootGetters }, code) {
    var client = rootGetters.getLenderApigClientFactory
    var params = {'code': code}
    var pathTemplate = '/lenders/{code}'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    try {
      var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      if ('brokerage_name' in result.data) commit('updateBrokerageName', result.data.brokerage_name)
      if ('brokerage_picture' in result.data) commit('updateBrokeragePicture', result.data.brokerage_picture)
      if ('license_number' in result.data) commit('updateLicenseNumber', result.data.license_number)
      if ('lender_phone_number' in result.data) commit('updatePhoneNumber', result.data.lender_phone_number)
      if ('lender_picture' in result.data) commit('updateProfilePicture', result.data.lender_picture)
      if ('code' in result.data) commit('updateLenderCode', result.data.code)
      if ('lender_cognito_id' in result.data) commit('updateLenderCognitoId', result.data.lender_cognito_id)
      if ('background_color' in result.data) commit('updateLenderBackgroundColor', result.data.background_color)
      if ('text_color' in result.data) commit('updateLenderTextColor', result.data.text_color)
      if ('lender_email' in result.data) commit('updateLenderEmail', result.data.lender_email)
      if ('lender_name' in result.data) commit('updateLenderName', result.data.lender_name)
      if ('subscription' in result.data) {
        commit('updateSubscriptionId', result.data.subscription.subscription_id)
        commit('updateSubscriptionPrice', result.data.subscription.price)
        commit('updateSubscriptionStartDate', result.data.subscription.billing_period_start_date)
        commit('updateSubscriptionEndDate', result.data.subscription.billing_period_end_date)
        commit('updateSubscriptionCreditCardType', result.data.subscription.credit_card_type)
        commit('updateSubscriptionCreditCardLastFour', result.data.subscription.credit_card_last_four)
        if (result.data.subscription.custom) commit('updateSubscriptionCustomFlag', result.data.subscription.custom)
        if (result.data.subscription.discount_amount) {
          commit('updateSubscriptionDiscountAmount', result.data.subscription.discount_amount)
          commit('updateSubscriptionDiscountExpirationDate', result.data.subscription.discount_expiration_date)
        }
        if (result.data.subscription.next_billing_date) {
          commit('updateSubscriptionNextBillingDate', result.data.subscription.next_billing_date)
          commit('updateSubscriptionRenewal', true)
        } else {
          commit('updateSubscriptionNextBillingDate', defaultValues.lenderSubscriptionNextBillingDate)
          commit('updateSubscriptionRenewal', defaultValues.lenderSubscriptionRenewal)
        }
      }
      if ('client_ids' in result.data) commit('updateClientIds', result.data.client_ids)
      if ('braintree_customer_id' in result.data) commit('updateBraintreeCustomerId', result.data.braintree_customer_id)
      if ('premium' in result.data) commit('updatePremium', result.data.premium)

      // Branch.io
      await branch.init('key_live_nFaPuSmOB2hCwygeBw93Glgntra7knUf', function (err, data) {
        if (err) {
          console.log(err)
        }
      })
      var linkData = {
        campaign: 'Lender Generated',
        channel: 'website',
        feature: 'referral',
        stage: 'premium',
        tags: [ 'lender', 'website' ],
        data: {
          'loan_officer_code': state.lenderCode,
          'name': state.lenderName,
          'profile_picture': 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/' + state.profilePicture,
          '$og_title': 'Connect with ' + state.lenderName + ' on Yarlow today!',
          '$og_description': 'Homes are a valuable asset.  Yarlow makes it easier to take care of yours.  Connecting with ' + state.lenderName + ' in the app means that your trusted lender is just a click away.',
          '$og_image_url': 'https://lender.yarlow.com/static/favicon.png',
          '$og_url': 'https://www.yarlow.com/'
        }
      }
      await branch.link(linkData, async function (err, generatedLink) {
        if (err) {
          console.log(err)
        } else {
          commit('updateBranchLink', generatedLink)
          commit('updateBranchQRCode', await QRCode.toDataURL(generatedLink))
        }
      })
    } catch (error) {
      console.log(error)
    }
  },
  async putLenderData ({ commit, state, rootGetters }, { code, method = 'PUT' }) {
    var client = rootGetters.getLenderApigClientFactory
    var params = {'code': code}
    var pathTemplate = '/lenders/{code}'
    var additionalParams = {}
    var body = {
      'lender_cognito_id': state.lenderCognitoId,
      'license_number': state.licenseNumber,
      'brokerage_name': state.brokerageName,
      'brokerage_picture': state.brokeragePicture,
      'background_color': state.lenderBackgroundColor,
      'text_color': state.lenderTextColor,
      'lender_name': state.lenderName,
      'lender_picture': state.profilePicture,
      'lender_phone_number': state.phoneNumber,
      'lender_email': state.lenderEmail
    }
    return client.invokeApi(params, pathTemplate, method, additionalParams, body)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/lender.js